// Constantes.
// ----------------------------------------------------------------------
export const DEFAULT_MODE = 'light';
export const DEFAULT_COLUMN_SIZE = '275px';
//# sourceMappingURL=Kanban.constants.js.map